import Cookies from 'js-cookie'
import { getLanguage } from '@/lang/index'

export default {
  state: {
    language: getLanguage(),
    navbarExpand: true
  },
  getters: {},
  mutations: {
    setLanguage: (state, lang) => {
      state.language = lang
      Cookies.set('sr.language', lang, { expires: 180 }) // 180天过期
    },
    setNavbarExpand: (state, status) => {
      state.navbarExpand = status
    }
  },
  actions: {}
}
